import { Sparkline } from './Sparkline';

export interface ChartBoxProps {
  data: number[];
  color: string;
  h?: number;
  className?: string;
}

export function ChartBox({ data, color, h = 46, className }: ChartBoxProps) {
  return (
    <div
      className={
        'bg-surfaceAlt rounded-md p-1 px-1.5 border border-borderSoft' +
        (className ? ` ${className}` : '')
      }
    >
      <Sparkline
        data={data}
        w="100%"
        h={h}
        color={color}
        fill={`${color}18`}
        strokeWidth={1.5}
      />
    </div>
  );
}

ChartBox.displayName = 'ChartBox';

export default ChartBox;
